import { useResetLinkQuery } from 'shared/hooks/queries/use-reset-link-query';

export const useResetLink = (oobCode?: string) => {
  const { data } = useResetLinkQuery(oobCode);

  return { email: data?.email ?? undefined, isDeadLink: !!data?.isDeadLink };
};
